import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/pdfs.svg'
import _imports_1 from '@/assets/sortByPrimary.svg'
import _imports_2 from '@/assets/cancel.svg'
import _imports_3 from '@/assets/Browse.svg'


const _hoisted_1 = { class: "maincontainer pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = {
  key: 0,
  class: "flex mr-4"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "w-full minheight" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "mainContainer tabStructure w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey flex" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "noScrollbar tabControlMapping"
}
const _hoisted_13 = { class: "flex flex-row mt-3" }
const _hoisted_14 = { class: "w-6/12" }
const _hoisted_15 = { class: "text-sm mt-2" }
const _hoisted_16 = { class: "w-6/12" }
const _hoisted_17 = { class: "text-sm mt-2" }
const _hoisted_18 = { class: "flex flex-row mt-3" }
const _hoisted_19 = { class: "w-6/12" }
const _hoisted_20 = { class: "text-sm mt-2" }
const _hoisted_21 = { class: "w-6/12" }
const _hoisted_22 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_23 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_24 = { class: "flex flex-row mt-3" }
const _hoisted_25 = { class: "w-6/12" }
const _hoisted_26 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_27 = { class: "w-6/12" }
const _hoisted_28 = {
  key: 2,
  class: "text-sm mt-2"
}
const _hoisted_29 = { class: "flex flex-row mt-3" }
const _hoisted_30 = { class: "w-6/12" }
const _hoisted_31 = { class: "text-sm mt-2" }
const _hoisted_32 = { class: "w-6/12" }
const _hoisted_33 = { class: "text-sm mt-2" }
const _hoisted_34 = { class: "flex flex-row mt-3" }
const _hoisted_35 = { class: "w-6/12" }
const _hoisted_36 = { class: "text-sm mt-2" }
const _hoisted_37 = { class: "w-6/12" }
const _hoisted_38 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_39 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_40 = { class: "w-full mt-3" }
const _hoisted_41 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_42 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_43 = { class: "flex flex-row mt-3" }
const _hoisted_44 = { class: "w-full" }
const _hoisted_45 = { class: "text-sm mt-2" }
const _hoisted_46 = { class: "w-full mt-3" }
const _hoisted_47 = { class: "text-sm mt-2" }
const _hoisted_48 = { class: "flex flex-row mt-3" }
const _hoisted_49 = { class: "w-full" }
const _hoisted_50 = { class: "text-sm mt-2" }
const _hoisted_51 = {
  key: 1,
  class: "pt-3 noScrollbar tabControlMapping"
}
const _hoisted_52 = { class: "flex justify-between" }
const _hoisted_53 = { class: "buttonposition flex justify-center items-center mb-1.5" }
const _hoisted_54 = {
  key: 0,
  class: "flex mt-4 gap-4 flex-wrap"
}
const _hoisted_55 = { class: "pdf w-full rounded-sm" }
const _hoisted_56 = ["href"]
const _hoisted_57 = {
  key: 0,
  class: "text-xs ml-2"
}
const _hoisted_58 = {
  key: 1,
  class: "text-xs ml-1"
}
const _hoisted_59 = {
  key: 2,
  class: "pt-3 noScrollbar tabControlMapping"
}
const _hoisted_60 = { class: "flex justify-between" }
const _hoisted_61 = { class: "buttonposition flex justify-center items-center mb-1.5" }
const _hoisted_62 = { class: "mt-4" }
const _hoisted_63 = {
  class: "ml-3",
  href: ""
}
const _hoisted_64 = {
  key: 3,
  class: "pt-3 noScrollbar tabControlMapping"
}
const _hoisted_65 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_66 = { class: "buttonposition flex justify-center items-center mb-1.5" }
const _hoisted_67 = { class: "mt-5" }
const _hoisted_68 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_69 = { class: "my-3" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "text-xs mt-1" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  key: 4,
  class: "pt-3 noScrollbar tabControlMapping"
}
const _hoisted_74 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_75 = { class: "buttonposition flex justify-center items-center mb-1.5" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { class: "initials cursor-pointer" }
const _hoisted_78 = { class: "flex" }
const _hoisted_79 = { class: "font-semibold cursor-pointer text-xs" }
const _hoisted_80 = { class: "flex" }
const _hoisted_81 = { class: "font-semibold cursor-pointer text-xs" }
const _hoisted_82 = {
  key: 5,
  class: "pt-3 noScrollbar tabControlMapping"
}
const _hoisted_83 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_84 = { class: "flex justify-center items-center mb-1.5" }
const _hoisted_85 = { class: "flex justify-center items-center" }
const _hoisted_86 = { class: "flex items-center" }
const _hoisted_87 = { class: "initials cursor-pointer" }
const _hoisted_88 = { class: "flex" }
const _hoisted_89 = { class: "font-semibold cursor-pointer text-xs" }
const _hoisted_90 = {
  key: 0,
  class: "mx-2 text-xs"
}
const _hoisted_91 = {
  key: 1,
  class: "mx-2 text-sm"
}
const _hoisted_92 = {
  key: 2,
  class: "mx-2 text-sm"
}
const _hoisted_93 = {
  key: 3,
  class: "mx-2 text-sm"
}
const _hoisted_94 = {
  key: 4,
  class: "mx-2 text-xs"
}
const _hoisted_95 = {
  key: 5,
  class: "mx-2 text-xs"
}
const _hoisted_96 = {
  key: 6,
  class: "mx-2 text-sm"
}
const _hoisted_97 = {
  key: 7,
  class: "mx-2 text-xs"
}
const _hoisted_98 = {
  key: 8,
  class: "mx-2 text-xs"
}
const _hoisted_99 = {
  key: 9,
  class: "mx-2 text-xs"
}
const _hoisted_100 = {
  key: 10,
  class: "mx-2 text-xs"
}
const _hoisted_101 = { class: "font-semibold cursor-pointer text-xs" }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { class: "flex pt-2" }
const _hoisted_104 = { class: "font-semibold px-2 hover:underline cursor-pointer" }
const _hoisted_105 = { class: "flex items-center" }
const _hoisted_106 = { class: "initials cursor-pointer" }
const _hoisted_107 = { class: "flex" }
const _hoisted_108 = { class: "font-semibold cursor-pointer text-xs" }
const _hoisted_109 = { class: "flex" }
const _hoisted_110 = { class: "font-semibold cursor-pointer" }
const _hoisted_111 = { class: "w-20 border taskDetailsRightBar rounded-sm border-lightgrey" }
const _hoisted_112 = { class: "m-3" }
const _hoisted_113 = { class: "pb-2" }
const _hoisted_114 = { key: 0 }
const _hoisted_115 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_116 = {
  key: 1,
  class: "pt-1.5 overflow-y-scroll thirtyWidthToggle"
}
const _hoisted_117 = { class: "mt-3" }
const _hoisted_118 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_119 = { class: "mt-3" }
const _hoisted_120 = {
  key: 0,
  class: "controllabel text-xs font-semibold mb-2"
}
const _hoisted_121 = {
  key: 1,
  class: "controllabel text-xs font-semibold mb-2"
}
const _hoisted_122 = {
  key: 2,
  class: "controllabel text-xs font-semibold mb-2"
}
const _hoisted_123 = { class: "mt-3" }
const _hoisted_124 = { class: "mt-3" }
const _hoisted_125 = { class: "mt-3" }
const _hoisted_126 = { class: "mt-3" }
const _hoisted_127 = { class: "my-2" }
const _hoisted_128 = { class: "userPopup" }
const _hoisted_129 = {
  key: 0,
  class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-indexx justify-center items-center flex"
}
const _hoisted_130 = { class: "relative my-6 w-full max-w-xl" }
const _hoisted_131 = { class: "border-0 rounded relative flex flex-col w-full bg-white" }
const _hoisted_132 = { class: "flex items-start justify-between p-5 rounded" }
const _hoisted_133 = { class: "p-2" }
const _hoisted_134 = { class: "text-black no-underline mt-0.5 min-h-30 cursor-pointer" }
const _hoisted_135 = { class: "p-4 flex flex-col mt-3" }
const _hoisted_136 = { class: "flex justify-center" }
const _hoisted_137 = {
  key: 1,
  class: "opacity-40 fixed inset-0 z-50 bg-black"
}
const _hoisted_138 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_139 = { class: "relative w-full max-w-xl" }
const _hoisted_140 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_141 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_142 = { class: "impactcontainer popupbodycontainer flex flex-col h-full" }
const _hoisted_143 = { class: "formcontainer flex-1 overflow-auto" }
const _hoisted_144 = { class: "row flex flex-col" }
const _hoisted_145 = { class: "upperspacing" }
const _hoisted_146 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_147 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_148 = { class: "upperspacing" }
const _hoisted_149 = {
  key: 0,
  class: "text-xs p-1"
}
const _hoisted_150 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_151 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_152 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_153 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_154 = { class: "flex flex-col h-full" }
const _hoisted_155 = { class: "flex-1 overflow-auto" }
const _hoisted_156 = { class: "popup-business" }
const _hoisted_157 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_158 = { class: "formcontainer flex flex-col" }
const _hoisted_159 = { class: "row flex flex-row upperspacing" }
const _hoisted_160 = { class: "w-full" }
const _hoisted_161 = { class: "row flex flex-row upperspacing" }
const _hoisted_162 = { class: "w-full" }
const _hoisted_163 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_164 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_165 = { class: "flex flex-col h-full" }
const _hoisted_166 = { class: "flex-1 overflow-auto" }
const _hoisted_167 = { class: "popup-business" }
const _hoisted_168 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_169 = { class: "formcontainer flex flex-col" }
const _hoisted_170 = { class: "row flex flex-row upperspacing" }
const _hoisted_171 = { class: "w-full" }
const _hoisted_172 = { class: "row flex flex-row" }
const _hoisted_173 = { class: "w-full" }
const _hoisted_174 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_175 = ["disabled"]
const _hoisted_176 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_commentsEditor = _resolveComponent("commentsEditor")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.riskName), 1),
      (_ctx.defaultTaskStatus!=null && !_ctx.dataLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              class: _normalizeClass((JSON.stringify(_ctx.taskObj)!=JSON.stringify(_ctx.dummyTaskObj)) ?'btnprimary':'btndisabled pointer-events-none'),
              disabled: _ctx.clickOnButton,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updatetask(_ctx.taskObj.taskStatus,'forStatus')))
            }, "Save", 10, _hoisted_5)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Tabs, {
            value: _ctx.selectedIndex,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedIndex) = $event)),
            scrollable: "",
            class: "w-80 heightFixing pr-5"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_TabList, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselHead, (tab) => {
                      return (_openBlock(), _createBlock(_component_Tab, {
                        key: tab.id,
                        value: tab.id,
                        onClick: ($event: any) => (_ctx.toggleTabs(tab))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tab.displayName), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselHead, (tab) => {
                    return (_openBlock(), _createBlock(_component_TabPanel, {
                      key: tab.id,
                      value: tab.id
                    }, {
                      default: _withCtx(() => [
                        (_ctx.dataLoading == true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_dots_loader)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              (tab.id == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createElementVNode("div", _hoisted_14, [
                                        _cache[35] || (_cache[35] = _createElementVNode("label", { class: "font-semibold controllabel" }, "Tier", -1)),
                                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.task.tierName != undefined && _ctx.task.tierName != '' ? _ctx.task.tierName   : 'N/A'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_16, [
                                        _cache[36] || (_cache[36] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Scope", -1)),
                                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.task.scopeName!= undefined&&_ctx.task.scopeName!= '' ? _ctx.task.scopeName: 'N/A'), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("div", _hoisted_19, [
                                        _cache[37] || (_cache[37] = _createElementVNode("label", { class: "font-semibold controllabel" }, "CID", -1)),
                                        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.task.clientUniqueId != undefined ? _ctx.task.clientUniqueId : 'N/A'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_21, [
                                        _cache[38] || (_cache[38] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Frequency", -1)),
                                        (_ctx.task.controlFrequency!= undefined&& _ctx.task.controlFrequency!='' )
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.getControlFrequency(_ctx.task.controlFrequency)), 1))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_23, "N/A"))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                      _createElementVNode("div", _hoisted_25, [
                                        _cache[39] || (_cache[39] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Priority", -1)),
                                        (_ctx.task.controlPriority && typeof _ctx.task.controlPriority === 'number')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorLabelBg(_ctx.task.controlPriority)])
                                            }, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.task.controlPriority)])
                                              }, _toDisplayString(_ctx.getProirityLabel(_ctx.task.controlPriority)), 3)
                                            ], 2))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_26, "N/A"))
                                      ]),
                                      _createElementVNode("div", _hoisted_27, [
                                        _cache[40] || (_cache[40] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Status", -1)),
                                        (_ctx.task.isActive && _ctx.task.isActive==true)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorStatusBg(1)])
                                            }, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["text-xs", _ctx.colorStatusText(1)])
                                              }, _toDisplayString(_ctx.getStatusLabel(1)), 3)
                                            ], 2))
                                          : (_ctx.task.isActive!=undefined && _ctx.task.isActive==false)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorStatusBg(2)])
                                              }, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["text-xs", _ctx.colorStatusText(2)])
                                                }, _toDisplayString(_ctx.getStatusLabel(2)), 3)
                                              ], 2))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_28, "N/A"))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("div", _hoisted_30, [
                                        _cache[41] || (_cache[41] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Class", -1)),
                                        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.task.controlClass != undefined&& _ctx.task.controlClass!='' ? _ctx.task.controlClass : 'N/A'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_32, [
                                        _cache[42] || (_cache[42] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Family", -1)),
                                        _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.task.controlFamily!= undefined && _ctx.task.controlFamily!= '' ? _ctx.task.controlFamily: 'N/A'), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                      _createElementVNode("div", _hoisted_35, [
                                        _cache[43] || (_cache[43] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Category", -1)),
                                        _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.task.controlType != undefined && _ctx.task.controlType != ''? _ctx.task.controlType : 'N/A'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_37, [
                                        _cache[44] || (_cache[44] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Owner", -1)),
                                        (_ctx.task.owner!= undefined)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(_ctx.getallUsers(_ctx.task.owner)), 1))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_39, "N/A"))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_40, [
                                      _cache[45] || (_cache[45] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Description", -1)),
                                      (_ctx.task.Description!= undefined&& _ctx.task.Description!='' )
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(_ctx.task.Description), 1))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_42, "N/A"))
                                    ]),
                                    _createElementVNode("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, [
                                        _cache[46] || (_cache[46] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Policy/Procedure", -1)),
                                        _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.task.controlPolicies != undefined && _ctx.task.controlPolicies != '' ? _ctx.task.controlPolicies : 'N/A'), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_46, [
                                      _cache[47] || (_cache[47] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Guidance", -1)),
                                      _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.task.controlGuidance!= undefined &&  _ctx.task.controlGuidance!=''? _ctx.task.controlGuidance: 'N/A'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_48, [
                                      _createElementVNode("div", _hoisted_49, [
                                        _cache[48] || (_cache[48] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Task", -1)),
                                        _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.task.controlMaintenanceTask!= undefined && _ctx.task.controlMaintenanceTask!= ''? _ctx.task.controlMaintenanceTask: 'N/A'), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (tab.id==2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_52, [
                                        _cache[49] || (_cache[49] = _createElementVNode("div", { class: "flex items-center marginTopForDoc marginBottomForDoc justify-center" }, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("p", { class: "my-1 header" }, "Attachments")
                                          ])
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_53, [
                                          _createElementVNode("button", {
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addDocuments())),
                                            for: "upload",
                                            class: "btnprimary flex justify-center taskEditButtons"
                                          }, "Attach")
                                        ])
                                      ])
                                    ]),
                                    _cache[51] || (_cache[51] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey" }, null, -1)),
                                    (Object.keys(_ctx.task).includes('documents'))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.documents, (doc) => {
                                            return (_openBlock(), _createElementBlock("div", { key: doc }, [
                                              _createElementVNode("div", _hoisted_55, [
                                                _createElementVNode("a", {
                                                  href: doc.documentUrl,
                                                  class: "flex w-full flex-row items-center"
                                                }, [
                                                  _cache[50] || (_cache[50] = _createElementVNode("img", {
                                                    src: _imports_0,
                                                    alt: ""
                                                  }, null, -1)),
                                                  (Object.keys(doc).includes('filename'))
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_57, _toDisplayString(doc.filename), 1))
                                                    : (_openBlock(), _createElementBlock("p", _hoisted_58, _toDisplayString(doc.documentName), 1))
                                                ], 8, _hoisted_56)
                                              ])
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (tab.id==4)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_60, [
                                        _cache[52] || (_cache[52] = _createElementVNode("div", { class: "flex items-center marginTopForDoc marginBottomForDoc justify-center" }, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("p", { class: "my-1 header" }, "Links")
                                          ])
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_61, [
                                          _createElementVNode("button", {
                                            class: "btnprimary taskEditButtons",
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenLinkTab()))
                                          }, "Links")
                                        ])
                                      ])
                                    ]),
                                    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey" }, null, -1)),
                                    _createElementVNode("table", _hoisted_62, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.link, (link) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          class: "mt-2",
                                          key: link
                                        }, [
                                          _createElementVNode("a", _hoisted_63, _toDisplayString(link.linkUrl), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (tab.id==5)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_65, [
                                        _cache[55] || (_cache[55] = _createElementVNode("div", { class: "flex items-center marginTopForDoc marginBottomForDoc justify-center" }, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("p", { class: "my-1 header" }, "Comments")
                                          ])
                                        ], -1)),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_66, [
                                            _createElementVNode("button", {
                                              class: "btnprimary w-24 flex taskEditButtons",
                                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortDates()))
                                            }, _cache[54] || (_cache[54] = [
                                              _createElementVNode("img", {
                                                src: _imports_1,
                                                class: "h-3 mr-2.5"
                                              }, null, -1),
                                              _createTextVNode(" Oldest ")
                                            ]))
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_67, [
                                      (_ctx.openTab == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                            _createElementVNode("div", _hoisted_69, [
                                              _createVNode(_component_commentsEditor)
                                            ]),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentsArray, (comment) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                class: "flex mt-4 singlecomment",
                                                key: comment.createdAt
                                              }, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["userContainer cursor-pointer p-2", { fullContainer: comment.isExpanded }])
                                                }, [
                                                  _createElementVNode("p", {
                                                    class: _normalizeClass(["font-semibold ellipsis-multiline-1", { expanded: comment.isExpanded }]),
                                                    onClick: ($event: any) => (_ctx.toggleCommentHeight(comment))
                                                  }, _toDisplayString(comment.user), 11, _hoisted_70),
                                                  _createElementVNode("p", _hoisted_71, _toDisplayString(comment.createdAt), 1)
                                                ], 2),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["commentContainer p-2", { fullContainer: comment.isExpanded }])
                                                }, [
                                                  _createElementVNode("p", {
                                                    ref_for: true,
                                                    ref: "commentParagraph",
                                                    class: _normalizeClass(["text-left ellipsis-multiline-2 cursor-pointer", { expanded: comment.isExpanded }]),
                                                    onClick: ($event: any) => (_ctx.toggleCommentHeight(comment))
                                                  }, _toDisplayString(_ctx.convertToPlainText(comment.comments)), 11, _hoisted_72)
                                                ], 2)
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (tab.id == 6)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_74, [
                                        _cache[56] || (_cache[56] = _createElementVNode("div", { class: "flex items-center marginTopForDoc marginBottomForDoc justify-center" }, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("p", { class: "my-1 header" }, "Approval")
                                          ])
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_75, [
                                          _createElementVNode("button", {
                                            class: _normalizeClass(["btnprimary flex justify-center", (_ctx.taskObj.assignee == '' || _ctx.taskObj.assignee == null || this.task.statusCode == 10403)?'btndisabled pointer-events-none taskEditApproval':'taskEditButtons']),
                                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.ApprovalTabDetails && _ctx.ApprovalTabDetails(...args)))
                                          }, " Send Approval ", 2)
                                        ])
                                      ])
                                    ]),
                                    (Object.keys(_ctx.task).includes('approval') && _ctx.task.approval.length >0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.approval, (member) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: member,
                                              class: "flex items-center p-2 w-full"
                                            }, [
                                              _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.extractInitials(_ctx.orgUsersList.find((user)=>{
												return user._id == _ctx.task.createdBy
											}).name)), 1),
                                              _createElementVNode("div", _hoisted_78, [
                                                _createElementVNode("div", _hoisted_79, _toDisplayString(this.orgUsersList.find((user)=>{
													return user._id == _ctx.task.createdBy
												}).name), 1),
                                                _createElementVNode("div", _hoisted_80, [
                                                  _cache[57] || (_cache[57] = _createElementVNode("p", { class: "mx-2 text-xs" }, _toDisplayString("Requested Approval from - "), -1)),
                                                  _createElementVNode("p", _hoisted_81, _toDisplayString(member.approval!= null ? _ctx.orgUsersList.find((user)=>{
														return user._id == member.approval
													}).name : 'N/A'), 1)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (tab.id == 7)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_83, [
                                        _cache[60] || (_cache[60] = _createElementVNode("div", { class: "flex items-center marginTopForDoc marginBottomForDoc justify-center" }, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("p", { class: "my-1 header" }, "Task History")
                                          ])
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_84, [
                                          _createElementVNode("div", _hoisted_85, [
                                            (_ctx.oldComments)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: "btnprimary w-24 flex taskEditButtons",
                                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortDates()))
                                                }, _cache[58] || (_cache[58] = [
                                                  _createElementVNode("img", {
                                                    src: _imports_1,
                                                    class: "h-3 mr-2.5"
                                                  }, null, -1),
                                                  _createTextVNode(" Oldest ")
                                                ])))
                                              : _createCommentVNode("", true),
                                            (!_ctx.oldComments)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 1,
                                                  class: "btnprimary w-24 flex taskEditButtons",
                                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortDates()))
                                                }, _cache[59] || (_cache[59] = [
                                                  _createElementVNode("img", {
                                                    src: _imports_1,
                                                    class: "h-3 mr-2.5 rotate-180"
                                                  }, null, -1),
                                                  _createTextVNode(" Newest ")
                                                ])))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskHistoryObject[0], (taskhistory) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: taskhistory,
                                        class: "bg-white pl-0 p-4 border-b border-lightgrey w-full"
                                      }, [
                                        _createElementVNode("div", _hoisted_86, [
                                          _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.extractInitials(_ctx.orgUsersList.find((user)=>{
											return user._id == taskhistory.createdBy
										}).name)), 1),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_88, [
                                              _createElementVNode("p", _hoisted_89, _toDisplayString(this.orgUsersList.find((user)=>{
													return user._id == taskhistory.createdBy
												}).name), 1),
                                              ((taskhistory.previousStatus==10401 && taskhistory.updatedStatus==10401))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString("Created this task on")))
                                                : (taskhistory.updatedStatus==10408 && Object.keys(taskhistory).includes('insertedIds') && taskhistory.insertedIds!=null)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_91, _toDisplayString('Created the Approval Task on')))
                                                  : (taskhistory.updatedStatus==10408 &&  Object.keys(taskhistory).includes('insertedIds') && taskhistory.insertedIds==null)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_92, _toDisplayString('Kept this Task in Approval on')))
                                                    : (taskhistory.updatedStatus==10410 && taskhistory.previousStatus==10408 && Object.keys(taskhistory).includes('taskId'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_93, _toDisplayString('Rejected the Approval Task on')))
                                                      : (taskhistory.updatedStatus==10410 && taskhistory.statusCode == 0)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_94, _toDisplayString('Rejected the Subtask on')))
                                                        : (taskhistory.updatedStatus==10403 && taskhistory.statusCode == 0)
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_95, _toDisplayString('Rejected this task on')))
                                                          : (taskhistory.updatedStatus==10403 && taskhistory.previousStatus==10408 && Object.keys(taskhistory).includes('taskId'))
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_96, _toDisplayString('Approved the Approval Task on')))
                                                            : (taskhistory.updatedStatus==10403 && taskhistory.statusCode != 0)
                                                              ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString('Accepted this task on')))
                                                              : (taskhistory.updatedStatus==10409)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_98, _toDisplayString('Kept this task in Review on')))
                                                                : (taskhistory.updatedStatus==10402)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_99, _toDisplayString('Kept this task in Progress on')))
                                                                  : (taskhistory.updatedStatus==10401)
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_100, _toDisplayString('Kept this task in Open on')))
                                                                    : _createCommentVNode("", true),
                                              _createElementVNode("p", _hoisted_101, _toDisplayString(_ctx.formatTime(taskhistory.createdAt)), 1)
                                            ]),
                                            (Object.keys(taskhistory).includes('insertedIds') && taskhistory.insertedIds!=null)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                                  _createElementVNode("div", _hoisted_103, [
                                                    _cache[61] || (_cache[61] = _createElementVNode("p", { class: "font-normal" }, "Approval Id:", -1)),
                                                    _createElementVNode("p", _hoisted_104, _toDisplayString(_ctx.getTaskInfo(taskhistory.insertedIds)), 1),
                                                    _cache[62] || (_cache[62] = _createElementVNode("p", { class: "font-normal" }, _toDisplayString("is Created"), -1))
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    }), 128)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.documents, (document) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: document,
                                        class: "bg-white pl-0 p-4 border-b border-lightgrey w-full"
                                      }, [
                                        _createElementVNode("div", _hoisted_105, [
                                          _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.extractInitials(_ctx.orgUsersList.find((user)=>{
											return user._id == _ctx.task.createdBy
										 }).name)), 1),
                                          _createElementVNode("div", _hoisted_107, [
                                            _createElementVNode("p", _hoisted_108, _toDisplayString(this.orgUsersList.find((user)=>{
												return user._id == _ctx.task.createdBy
											}).name), 1),
                                            _createElementVNode("div", _hoisted_109, [
                                              _cache[63] || (_cache[63] = _createElementVNode("p", { class: "mx-2 text-xs" }, "Uploaded file - ", -1)),
                                              _createElementVNode("p", _hoisted_110, _toDisplayString(document.documentName), 1)
                                            ])
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _createElementVNode("div", _hoisted_111, [
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("div", _hoisted_113, [
                _cache[72] || (_cache[72] = _createElementVNode("h1", { class: "font py-0.5 mt-2" }, "Risk Details", -1)),
                _cache[73] || (_cache[73] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mt-1 rounded" }, null, -1)),
                (_ctx.dataLoading == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                      _createElementVNode("div", _hoisted_115, [
                        _createVNode(_component_dots_loader)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_116, [
                      _createElementVNode("div", _hoisted_117, [
                        _cache[64] || (_cache[64] = _createElementVNode("label", { class: "controllabel text-xs font-semibold mb-2" }, "Task Status", -1)),
                        _createVNode(_component_Select, {
                          modelValue: _ctx.taskObj.taskStatus,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.taskObj.taskStatus) = $event)),
                          options: _ctx.taskStatusValue,
                          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getTaskStatusInfo())),
                          class: _normalizeClass([_ctx.changeBackground(), "white-label-select custom-multiselect w-full"]),
                          disabled: (_ctx.task.action!=10405 || _ctx.task.statusCode==10403 ) || (_ctx.taskObj.assignee == ""),
                          optionLabel: "value",
                          optionValue: "id",
                          placeholder: "Please select one"
                        }, null, 8, ["modelValue", "options", "class", "disabled"])
                      ]),
                      (_ctx.task.action == 10405)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                            _cache[66] || (_cache[66] = _createElementVNode("label", { class: "controllabel text-xs font-semibold mb-2" }, "Assignee", -1)),
                            _createVNode(_component_AutoComplete, {
                              modelValue: _ctx.taskObj.assignee,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.taskObj.assignee) = $event)),
                              suggestions: _ctx.userOptions,
                              onComplete: _ctx.asyncFind,
                              disabled: _ctx.task.statusCode == 10403,
                              placeholder: "Assignee",
                              optionLabel: "label",
                              optionValue: "value",
                              class: _normalizeClass(["w-full", {
								'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
								'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== '',
							}])
                            }, {
                              empty: _withCtx(() => _cache[65] || (_cache[65] = [
                                _createElementVNode("span", { class: "text-xs" }, "No Members Found", -1)
                              ])),
                              _: 1
                            }, 8, ["modelValue", "suggestions", "onComplete", "disabled", "class"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_119, [
                        (_ctx.task&&_ctx.task.orgId)
                          ? (_openBlock(), _createElementBlock("label", _hoisted_120, "Organization Name"))
                          : (_ctx.task&&_ctx.task.systemId)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_121, "System Name"))
                            : (_ctx.task&&_ctx.task.processId)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_122, "Process Name"))
                              : _createCommentVNode("", true),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "Name",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.taskObj.Name) = $event)),
                          class: _normalizeClass({
									'is-invalid': _ctx.v$.taskObj.Name.$error
								})
                        }, null, 2), [
                          [_vModelText, _ctx.taskObj.Name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_123, [
                        _cache[67] || (_cache[67] = _createElementVNode("label", { class: "controllabel text-xs font-semibold mb-2" }, "Severity", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "Severity",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.taskObj.severity) = $event)),
                          class: _normalizeClass({
									'is-invalid': _ctx.v$.taskObj.severity.$error
								})
                        }, null, 2), [
                          [_vModelText, _ctx.taskObj.severity]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_124, [
                        _cache[68] || (_cache[68] = _createElementVNode("label", { class: "controllabel text-xs font-semibold mb-2" }, "Impact", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "Impact",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.taskObj.impact) = $event)),
                          class: _normalizeClass({
									'is-invalid': _ctx.v$.taskObj.impact.$error
								})
                        }, null, 2), [
                          [_vModelText, _ctx.taskObj.impact]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_125, [
                        _cache[69] || (_cache[69] = _createElementVNode("label", { class: "controllabel text-xs font-semibold mb-2" }, "Likelihood", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "Likelihood",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.taskObj.likelihood) = $event)),
                          class: _normalizeClass({
									'is-invalid': _ctx.v$.taskObj.likelihood.$error
								})
                        }, null, 2), [
                          [_vModelText, _ctx.taskObj.likelihood]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_126, [
                        _cache[70] || (_cache[70] = _createElementVNode("label", { class: "controllabel text-xs font-semibold mb-2" }, "Risk Owner", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          placeholder: "Risk Owner",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.taskObj.riskOwner) = $event)),
                          class: _normalizeClass({
								'is-invalid': _ctx.v$.taskObj.riskOwner.$error
							})
                        }, null, 2), [
                          [_vModelText, _ctx.taskObj.riskOwner]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_127, [
                        _cache[71] || (_cache[71] = _createElementVNode("label", { class: "controllabel text-xs font-semibold mb-1" }, "Date of Request", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.taskObj.dateOfRequest) = $event)),
                          class: _normalizeClass({
								'is-invalid': _ctx.v$.taskObj.dateOfRequest.$error
							})
                        }, null, 2), [
                          [_vModelText, _ctx.taskObj.dateOfRequest]
                        ])
                      ])
                    ]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_128, [
          (_ctx.showTaskModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                _createElementVNode("div", _hoisted_130, [
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("div", _hoisted_132, [
                      _cache[75] || (_cache[75] = _createElementVNode("h1", null, "Add Links", -1)),
                      _createElementVNode("button", {
                        class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onCloseLink()))
                      }, _cache[74] || (_cache[74] = [
                        _createElementVNode("img", {
                          src: _imports_2,
                          class: "h-5 w-5 cursor-pointer"
                        }, null, -1)
                      ]))
                    ]),
                    _createElementVNode("div", _hoisted_133, [
                      _createElementVNode("div", _hoisted_134, [
                        _createElementVNode("div", null, [
                          _cache[76] || (_cache[76] = _createElementVNode("hr", { class: "border-t-2" }, null, -1)),
                          _createElementVNode("div", _hoisted_135, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "inputboxstyling mt-2 w-96 ml-2",
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.mainLinkName) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.mainLinkName]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_136, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["mb-4", _ctx.mainLinkName != undefined && _ctx.mainLinkName!= '' ? 'btnprimary' : 'btndisabled pointer-events-none']),
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.saveLinks()))
                            }, "Save", 2)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTaskModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_137))
            : _createCommentVNode("", true)
        ]),
        (_ctx.newImportModal)
          ? (_openBlock(), _createBlock(_component_popup, {
              key: 0,
              class: "importpopup",
              popUp: _ctx.newImportModal
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_138, [
                  _createElementVNode("div", _hoisted_139, [
                    _createElementVNode("div", _hoisted_140, [
                      _createElementVNode("div", _hoisted_141, [
                        _cache[78] || (_cache[78] = _createElementVNode("h1", null, "Import files", -1)),
                        _createElementVNode("button", {
                          class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onCancelIcon()))
                        }, _cache[77] || (_cache[77] = [
                          _createElementVNode("img", {
                            src: _imports_2,
                            class: "h-5 w-5 cursor-pointer"
                          }, null, -1)
                        ]))
                      ]),
                      _cache[83] || (_cache[83] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                      _createElementVNode("div", _hoisted_142, [
                        _createElementVNode("div", _hoisted_143, [
                          _createElementVNode("div", _hoisted_144, [
                            _createElementVNode("div", _hoisted_145, [
                              _cache[79] || (_cache[79] = _createElementVNode("label", { class: "controllabel" }, "File Name ", -1)),
                              _withDirectives(_createElementVNode("input", {
                                class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.inputFileName.$error }]),
                                type: "text",
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.inputFileName) = $event)),
                                placeholder: "Filename"
                              }, null, 2), [
                                [_vModelText, _ctx.inputFileName]
                              ]),
                              (_ctx.v$.inputFileName.$error )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                    (_ctx.v$.inputFileName.required.$invalid )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_147, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_148, [
                              _cache[81] || (_cache[81] = _createElementVNode("label", { class: "controllabel" }, "Attachment", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-auto evidenceHeight bg-white rounded-sm border-solid border border-lightgrey relative overflow-hidden mt-2", {'is-invalid':_ctx.v$.fileToUpload.$error}])
                              }, [
                                _createElementVNode("input", {
                                  type: "file",
                                  id: "upload",
                                  ref: "element",
                                  class: "hidden",
                                  placeholder: "Choose a file to upload",
                                  onChange: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                                }, null, 544),
                                _cache[80] || (_cache[80] = _createElementVNode("label", {
                                  for: "upload",
                                  class: "float-right cursor-pointer text-white flex justify-center items-center w-9 h-7 bg-primary"
                                }, [
                                  _createElementVNode("img", { src: _imports_3 })
                                ], -1)),
                                (_ctx.fileName)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_149, _toDisplayString(_ctx.fileName), 1))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            (_ctx.v$.fileToUpload.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                  (_ctx.v$.fileToUpload.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_151, "File upload is required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[82] || (_cache[82] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                        _createElementVNode("div", _hoisted_152, [
                          _createElementVNode("button", {
                            class: _normalizeClass((_ctx.inputFileName.length == 0) ? 'btndisabled pointer-events-none ' : 'btnprimary'),
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.saveDocuments()))
                          }, "Save", 2)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["popUp"]))
          : _createCommentVNode("", true),
        (_ctx.showApprovalPopup)
          ? (_openBlock(), _createBlock(_component_popup, {
              key: 1,
              popUp: _ctx.showApprovalPopup
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_153, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.riskName), 1),
                  _createElementVNode("button", {
                    class: "float-right text-3xl",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onCrossbtn('approval')))
                  }, _cache[84] || (_cache[84] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "h-5 w-5 cursor-pointer"
                    }, null, -1)
                  ]))
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_154, [
                  _createElementVNode("div", _hoisted_155, [
                    _createElementVNode("div", _hoisted_156, [
                      _createElementVNode("div", _hoisted_157, [
                        _createElementVNode("div", _hoisted_158, [
                          _createElementVNode("div", _hoisted_159, [
                            _createElementVNode("div", _hoisted_160, [
                              _cache[86] || (_cache[86] = _createElementVNode("label", { class: "controllabel" }, "Name of the Authority", -1)),
                              _createVNode(_component_multiselect, {
                                modelValue: _ctx.taskObj.approval,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.taskObj.approval) = $event)),
                                options: _ctx.userOptions,
                                showNoOptions: false,
                                onSearchChange: _ctx.asyncFind1,
                                "limit-text": _ctx.limitText,
                                multiple: false,
                                "hide-selected": true,
                                "close-on-select": true,
                                "clear-on-select": true,
                                "open-direction": "bottom",
                                label: "label",
                                "track-by": "value",
                                searchable: true,
                                hideArrow: false,
                                placeholder: "Approver",
                                class: _normalizeClass(["custom-multiselect userSelect", {
															'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
															'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== '',
														}])
                              }, {
                                noResult: _withCtx(() => _cache[85] || (_cache[85] = [
                                  _createElementVNode("span", { class: "text-xs" }, "No Members Found", -1)
                                ])),
                                _: 1
                              }, 8, ["modelValue", "options", "onSearchChange", "limit-text", "class"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_161, [
                            _createElementVNode("div", _hoisted_162, [
                              _cache[87] || (_cache[87] = _createElementVNode("label", { class: "controllabel" }, "Justification or Comments for Approving", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: "inputboxstyling",
                                placeholder: "Comments",
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.approvalComments) = $event))
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.approvalComments,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[88] || (_cache[88] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                    _createElementVNode("div", _hoisted_163, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btnprimary mr-2", (_ctx.approvalComments==''||_ctx.taskObj.approval=='')?'btndisabled pointer-events-none':'btnprimary']),
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onCancelbtn('approval')))
                      }, "Reset", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["btnprimary", (_ctx.approvalComments==''||_ctx.taskObj.approval=='')?'btndisabled pointer-events-none':'btnprimary']),
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.applyAuthority(10408,_ctx.taskObj)))
                      }, "Save", 2)
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["popUp"]))
          : _createCommentVNode("", true),
        (_ctx.showCloseStatusPopup)
          ? (_openBlock(), _createBlock(_component_popup, {
              key: 2,
              popUp: _ctx.showCloseStatusPopup
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_164, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.riskName), 1),
                  _createElementVNode("button", {
                    class: "float-right text-3xl",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onCrossbtn('close')))
                  }, _cache[89] || (_cache[89] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "h-5 w-5 cursor-pointer"
                    }, null, -1)
                  ]))
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_165, [
                  _createElementVNode("div", _hoisted_166, [
                    _createElementVNode("div", _hoisted_167, [
                      _createElementVNode("div", _hoisted_168, [
                        _createElementVNode("div", _hoisted_169, [
                          _createElementVNode("div", _hoisted_170, [
                            _createElementVNode("div", _hoisted_171, [
                              _cache[90] || (_cache[90] = _createElementVNode("label", { class: "controllabel" }, "Resolution", -1)),
                              _createVNode(_component_Select, {
                                modelValue: _ctx.taskObj.taskStatus,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.taskObj.taskStatus) = $event)),
                                options: _ctx.ClosingTaskStatusValue,
                                onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.getTaskStatusInfo())),
                                optionLabel: "value",
                                optionValue: "id",
                                placeholder: "Please select one",
                                class: "custom-multiselect w-full"
                              }, null, 8, ["modelValue", "options"])
                            ])
                          ]),
                          _cache[92] || (_cache[92] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey upperspacing" }, null, -1)),
                          _createElementVNode("div", _hoisted_172, [
                            _createElementVNode("div", _hoisted_173, [
                              _cache[91] || (_cache[91] = _createElementVNode("label", { class: "controllabel" }, "Justification or Comments for Closing", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: "inputboxstyling",
                                placeholder: "Comments",
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.closingComments) = $event))
                              }, null, 512), [
                                [
                                  _vModelText,
                                  _ctx.closingComments,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _cache[93] || (_cache[93] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                  _createElementVNode("div", _hoisted_174, [
                    _createElementVNode("button", {
                      disabled: _ctx.clickOnButton,
                      class: "btnprimary mr-1.5",
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.onCancelbtn('close')))
                    }, "Reset", 8, _hoisted_175),
                    _createElementVNode("button", {
                      class: _normalizeClass(["btnprimary", (_ctx.closingComments==''||_ctx.taskObj.taskStatus=='')?'btndisabled pointer-events-none':'btnprimary']),
                      disabled: _ctx.clickOnButton,
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.updatetask(_ctx.taskObj.taskStatus,'forStatus')))
                    }, "Save", 10, _hoisted_176)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["popUp"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}